import React, { useEffect, useState, useCallback } from "react";
import { ReportListingHeader,AppointmentFilter ,ReportCard ,AppointmentCancellationModal } from "tutorapp-components";
import { useNavigate } from "react-router-dom";
import "./reportlisting.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchUpcomingSessions, resetUpcomingSessions } from "../redux/actions/upcomingSessionActions";
import {  resetSessionData } from "../redux/actions/sessionActions";
import { apiService } from "../utils/apiRequest";
import CircularProgress from "@mui/material/CircularProgress";
import InfiniteScroll from "react-infinite-scroll-component";
import { useMemo } from "react";
import debounce from "lodash/debounce";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import { setUserPreferences } from "../redux/actions/userPreferencesActions";
import { setsessionid } from "../redux/actions/sessionActions";
import { setShowReportButton } from "../redux/actions/sessionActions";
import { resetSchoolSessions } from "../redux/actions/schoolsessionActions";

export default function ReportListingPage() {
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [appointmentId, setAppointmentId] = useState();
  const [sessionType, setSessionType] = useState();
  const [rescheduleModalVisible, setRescheduleModalVisible] = useState(false);
  const [reportType, setReportType] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [sessionsList, setSessionsList] = useState([]);
  const [sessionstatus, setSessionStatus] = useState("all");
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [date, setDate] = useState(null);
  const [joblist, setJoblist] = useState();
  const [subjectlist, setSubjectlist] = useState();
  const [studentlist, setStudentlist] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [appointmentModaldData, setAppointmentModalData] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
  const { upcomingSessions, sessionloading } = useSelector((state) => state.upcomingSessions);
  const userPreferences = useSelector((state) => state.userPreferences);
    const showschool = selectedFranchise.country == 'UK'


  useEffect(() => {
    dispatch(resetSessionData());    
    dispatch(resetUpcomingSessions());
    dispatch(resetSchoolSessions())
  }, [dispatch]);

  const imagePaths = {
    calender: "./images/ic_calender.svg",
    time: "./images/ic_time.svg",
    down: "./images/ic_down.svg",
  };

  const icons = {
    search: "./images/ic_search.svg",
    back: "./images/left.svg",
    filter: "./images/Filter.svg",
  };

  const icon = {
    view: "./images/view.svg",
    reschedule: "./images/Add.svg",
    cancel: "./images/Cancel.svg",
    optionsmenu: "./images/ic_options.svg",
    warning: "./images/warning.png",
    close: "./images/ic_close2.svg",
  };

  const getStudentsBySubject = (subjectName, data) => {
    if (!data?.students) return [];
    const students = data.students;
    return students.filter(student => student.subject === subjectName);
  };

  const filters = useMemo(() => {
    const baseFilters = {
      AppointmentType: showschool ? ['All', 'Families', 'Schools'] : ['All', 'Families'],
      SessionType: ["All", "Online", "In Person"],
      Subject: subjectlist,
      students: [],
    };

      if (showschool) {
    baseFilters.JobName = joblist;
  }

    if (studentlist && typeof studentlist === 'object') {
      const studentArray = Object.values(studentlist);
      const selectedSubject = selectedFilters.find(f => f.section === "Subject")?.value[0]?.name;
      if (selectedSubject) {
        baseFilters.students = getStudentsBySubject(selectedSubject, { students: studentArray });
      } else {
        baseFilters.students = studentArray.map(student => ({
          id: student.id,
          name: student.name,
          subject: student.subject,
        }));
      }
    }

    return baseFilters;
  }, [joblist, subjectlist, studentlist, selectedFilters , showschool]);

  const filterSections = [
    { key: "AppointmentType", label: "Appointment Type" },
    { key: "SessionType", label: "Session Type" },
    { key: "Subject", label: "Subject" },
    { key: "students", label: "Students" },
  ];
  
 if (showschool) {
    filterSections.splice(1, 0, { key: 'JobName', label: 'Job Name' }); // Insert JobName after AppointmentType
  }

  const handleFilterChange = (filter) => {
    setReportType(filter);
    setSessionStatus(filter);
  };

  const handleSelectFilter = (newFilters) => {
    setSelectedFilters(newFilters);
  };

  const handleClearAll = () => {
    setSelectedFilters([]);
  };

  function handleSaveChanges(appointmentModalData) {
    const action = 'cancel';
    cancelAppointment(appointmentModalData?.appointment_id, action);
  }

  function transformData(data) {
    const result = {
      appointment_type: null,
      session_type: null,
      student_id: [],
      job_id: [],
      subject_id: [],
    };

    data.forEach((item) => {
      const section = item.section;
      const values = item.value;

      switch (section) {
        case "AppointmentType":
          if (values === "All") result.appointment_type = "";
          else if (values === "Families") result.appointment_type = 0;
          else if (values === "Schools") result.appointment_type = 1;
          else result.appointment_type = "";
          break;
        case "SessionType":
          if (values === "All") result.session_type = "";
          else if (values === "In Person") result.session_type = "InPerson";
          else if (values === "Online") result.session_type = "Online";
          else result.session_type = "";
          break;
        case "JobName":
          result.job_id = values.map((v) => v.id);
          break;
        case "Subject":
          result.subject_id = values.map((v) => v.id);
          break;
        case "students":
          result.student_id = values.map((v) => v.id);
          break;
      }
    });

    return result;
  }

  const fetchMoreSessions = () => {
    let apiStatus;
    switch (sessionstatus.toUpperCase()) {
      case "PENDING":
        apiStatus = "Pending";
        break;
      case "SUBMITTED":
        apiStatus = "Report Submitted";
        break;
      case "APPROVED":
        apiStatus = "Report Approved";
        break;
      case "FOLLOW-UP":
        apiStatus = "follow-up" 
        break;
      default:
        apiStatus = "all";
    }
    const filterdata = transformData(selectedFilters);

    setPage((prevPage) => {
      const newPage = prevPage + 1;
      dispatch(fetchUpcomingSessions(selectedFranchise, newPage, apiStatus, filterdata, searchQuery));
      return newPage;
    });
  };

  useEffect(() => {
    if (upcomingSessions?.userPreferences) {
      const prefs = upcomingSessions.userPreferences || {};
      const { timezone = 'UTC', dateformat = 'MM/DD/YYYY', timeformat = 'hh:mm A' } = prefs;
      dispatch(setUserPreferences({ timezone, dateformat, timeformat }));
    }
  }, [upcomingSessions, dispatch]);

  const getjoblisting = async (selectedFranchise) => {
    try {
      setLoading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + "getAllJob";
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ franchise_id: selectedFranchise.franchise_id, tutor_id: selectedFranchise.tutor_id }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === "success") {
        setJoblist(response.job);
      } else {
        console.error("Failed to fetch jobs:", response.message);
      }
    } catch (error) {
      console.error("Error while fetching jobs:", error);
    }
  };

  const getsubjectlisting = async (selectedFranchise) => {
    try {
      setLoading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + "getAllSubject";
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ franchise_id: selectedFranchise.franchise_id, tutor_id: selectedFranchise.tutor_id }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === "success") {
        setSubjectlist([...response.schools_subject, ...response.families_subject]);
      } else {
        console.error("Failed to fetch subjects:", response.message);
      }
    } catch (error) {
      console.error("Error while fetching subjects:", error);
    } 
  };

  const getstudentlisting = async (selectedFranchise) => {
    try {

      setLoading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + "getAllStudent";
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ franchise_id: selectedFranchise.franchise_id, tutor_id: selectedFranchise.tutor_id }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === "success") {
        const mergedStudents = [
          ...Object.values(response.schools_student || {}),
          ...Object.values(response.families_student || {}),
        ];
        setStudentlist(mergedStudents);
      } else {
        console.error("Failed to fetch students:", response.message);
      }
    } catch (error) {
      console.error("Error while fetching students:", error);
    } finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    if (!selectedFranchise) return;

    const fetchInitialSessions = () => {
      setSessionsList([]);
      setPage(1);
      setHasMore(true);
      const filterdata = transformData(selectedFilters);

      let apiStatus;
      switch (sessionstatus.toUpperCase()) {
        case "PENDING":
          apiStatus = "Pending";
          break;
        case "SUBMITTED":
          apiStatus = "Report Submitted";
          break;
        case "APPROVED":
          apiStatus = "Report Approved";
          break;
           case "FOLLOW-UP":
        apiStatus = "follow-up" 
        break;
        default:
          apiStatus = "all";
      }

      dispatch(fetchUpcomingSessions(selectedFranchise, 1, apiStatus, filterdata, searchQuery));
    };

    fetchInitialSessions();
  }, [selectedFranchise, sessionstatus, dispatch, selectedFilters, searchQuery]);

  useEffect(() => {
    if (upcomingSessions.sessions && upcomingSessions.sessions.length >= 0) {
      const newSessions = upcomingSessions.sessions || [];
      setSessionsList((prev) => {
        const existingIds = new Set(prev.map((session) => session.appointment_id));
        const filteredNewSessions = newSessions.filter((session) => !existingIds.has(session.appointment_id));
        return [...prev, ...filteredNewSessions];
      });
    }
  }, [upcomingSessions.sessions]);

  const debouncedFetchSessions = useCallback(
    debounce((query) => {
      if (query.length >= 3) {
        setSessionsList([]);
        setPage(1);
        setHasMore(true);

        const filterdata = transformData(selectedFilters);
        let apiStatus;
        switch (sessionstatus.toUpperCase()) {
          case "PENDING":
            apiStatus = "Pending";
            break;
          case "SUBMITTED":
            apiStatus = "Report Submitted";
            break;
          case "APPROVED":
            apiStatus = "Report Approved";
            break;
             case "FOLLOW-UP":
        apiStatus = "follow-up" 
            break;
          default:
            apiStatus = "all";
        }

        dispatch(fetchUpcomingSessions(selectedFranchise, 1, apiStatus, filterdata, query));
      }
    }, 500),
    [dispatch, selectedFranchise, sessionstatus, selectedFilters]
  );

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const formatTime = (time) => {
    return time ? `${time}:00` : "";
  };

  const handleclose = () => {
    setRescheduleModalVisible(false);
  };

  const cancelAppointment = async (appointmentId, action) => {
    try {
      setLoading(true);
      const cancelappointment = process.env.REACT_APP_API_URL + "getCancelAppointment";
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment_id: appointmentId?.appointment_id, action }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === "success") {
        dispatch(fetchUpcomingSessions(selectedFranchise, 1));
        setSessionsList([]);
        setPage(1);
        setModalVisible(false);
        setLoading(false);
        setShow(false);

        toast.success(response.message, {
          position: "top-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#388E3C", color: "#fff", fontWeight: "500" },
        });
      } else {
        console.error("Failed to cancel appointment:", response.message);
        setShow(false);
        setModalVisible(false);
        toast.error(response.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" },
        });
      }
    } catch (error) {
      console.error("Error while cancelling appointment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = (action) => {
    cancelAppointment(appointmentId, action);
    setModalVisible(false);
  };

  const handleReschedule = (appointmentid, sessiontype) => {
    setAppointmentId(appointmentid);
    setSessionType(sessiontype);
    setRescheduleModalVisible(true);
  };

  const handleCancel = (appointment) => {
    setPage(1);
    setAppointmentId(appointment);
    if (appointment.appointment_for === 'Families' || appointment.session_for === 'Families') {
      setAppointmentModalData(true);
      setModalVisible(true);
    } else {
       setAppointmentModalData(false)
      setModalVisible(true);
    }
  };

  const handlefilter = () => {
    setFilterModalVisible(!filterModalVisible);
    getjoblisting(selectedFranchise);
    getsubjectlisting(selectedFranchise);
    getstudentlisting(selectedFranchise);
  };

  const handleSearchChange = (text) => {
    setSearchQuery(text);
    debouncedFetchSessions(text);
  };

  const handleCreatReport = (data) => {
    const formattedData = {
      appointment_id: data.appointment_id,
      submitted_by: selectedFranchise?.tutor_id,
      userpreference: upcomingSessions.userPreferences,
    };
      dispatch(setsessionid(data.appointment_id))
        dispatch(setUserPreferences(upcomingSessions?.userPreferences))
    // dispatch(addSession(formattedData));
      dispatch(setShowReportButton(data.status))
    navigate("/sessiondetails");
  };

  const handleback = () => {
    dispatch(resetUpcomingSessions());
    navigate("/Myappointment");
  };

  const handleView = (data) => {
     const formattedData = {
          appointment_id: data?.appointment_id,
          submitted_by: selectedFranchise?.tutor_id,
          userpreference: upcomingSessions.userPreferences,
        };
        // dispatch(addSession(formattedData));
          dispatch(setsessionid(data?.appointment_id))
            dispatch(setUserPreferences(upcomingSessions?.userPreferences))
              dispatch(setShowReportButton(data.status))
            navigate("/sessiondetails");
  };

  const applyFilters = () => {
   
    setFilterModalVisible(false);
  };

  useEffect(() => {
    if (upcomingSessions?.status === 'fail' || upcomingSessions?.sessions?.length < 25) {
      setHasMore(false);
    }
  }, [upcomingSessions]);

  return (
    <>
      {/* Full-screen overlay when sessionloading is true */}
      {sessionloading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // Ensure it appears above other elements
            pointerEvents: "all", // Block interactions with elements underneath
          }}
        >
          <CircularProgress style={{ color: "black" }} size={30} />
        </div>
      )}

      <div className="sticky-header bg-white shadow-sm">
        <ReportListingHeader
          icons={icons}
          handleback={handleback}
          onFilterChange={handleFilterChange}
          handlefilter={handlefilter}
          onSearchChange={handleSearchChange}
          searchTerm={searchQuery}
        />
      </div>

      <div className="p-3">
        <InfiniteScroll
          dataLength={sessionsList.length}
          next={fetchMoreSessions}
          hasMore={hasMore}
          endMessage={
            <div
              className="text-center text-secondary"
              style={{ fontFamily: 'GT-Walsheim', margin: 0, paddingBottom: 0 }}
            >
              No more reports to load.
            </div>
          }
          style={{ overflow: 'visible', fontFamily: 'GT-Walsheim' }}
        >
          <div className="row custom-row-gap justify-content-center">
            {sessionsList.map((report, index) => (
              <div key={index} className="col-12 col-sm-6 col-md-6 d-flex justify-content-center">
                <ReportCard
                  item={report}
                  onViewPress={handleView}
                  onReschedulePress={handleCreatReport}
                  onCancelPress={handleCancel}
                  icons={icon}
                  onReportPress={handleCreatReport}
                  userPreferences={userPreferences}
                />
              </div>
            ))}
          </div>
        </InfiniteScroll>
      </div>

      <AppointmentFilter
        isVisible={filterModalVisible}
        onClose={applyFilters}
        filters={filters}
        selectedFilters={selectedFilters}
        onSelectFilter={handleSelectFilter}
        handlefilter={handlefilter}
        onClearAll={handleClearAll}
        filterSections={filterSections}
        students={filters.students}
        isloading={loading}
        icons={{
          close: "./images/ic_close2.svg",
          chevronup: "./images/dropdown.svg",
          chevrondown: "./images/dropdown_close.svg",
          closeoption: "./images/filter_close.svg",
          studentsearch: "./images/Search.svg"

        }}
      />

      <AppointmentCancellationModal
        appointmentfor ={appointmentModaldData}

        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onConfirm={handleConfirm}
      />
     
      <ToastContainer />
    </>
  );
}